import { usePageQuery } from '@/utils/dato/generated';
import { pageQueryKey } from '@/utils/ab/pageQueryKey';
import type { PageContext } from '@/utils/models/page';

/**
 * The page's DatoCMS data. It reads from the same React Query key serverSideProps dehydrated under, which is per
 * bucket on experiment pages (see pageQueryKey), so a client-side return in another bucket is a new query.
 *
 * Experiment pages keep the server's data, which holds only the slot being shown: a refetch would bring back both
 * variants' content and cost a DatoCMS call. Fastly purges the page when it is republished.
 */
export function usePageData({ experiment, pageSlug, bucket }: Pick<PageContext, 'experiment' | 'pageSlug' | 'bucket'>) {
  return usePageQuery(
    { pageSlug },
    {
      queryKey: pageQueryKey(pageSlug, bucket),
      ...(experiment ? { staleTime: Infinity } : {}),
    },
  );
}
